import { render, staticRenderFns } from "./noMore.vue?vue&type=template&id=4f8398d0&scoped=true"
import script from "./noMore.vue?vue&type=script&lang=js"
export * from "./noMore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8398d0",
  null
  
)

export default component.exports